class Wishlist {
  constructor(storageKey = "wishlist") {
    this.storageKey = storageKey;
  }

  getItems() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch {
      return [];
    }
  }

  saveItems(items) {
    localStorage.setItem(this.storageKey, JSON.stringify(items));
    document.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: items,
      }),
    );
  }

  add(product) {
    const items = this.getItems();

    if (items.some((item) => item.variantId === product.variantId)) {
      return;
    }

    items.push({
      productId: product.productId,
      variantId: product.variantId,
      handle: product.handle,
      addedAt: new Date().toISOString(),
    });

    this.saveItems(items);
  }

  remove(variantId) {
    const items = this.getItems().filter((item) => item.variantId !== variantId);
    this.saveItems(items);
  }

  toggle(product) {
    if (this.exists(product.variantId)) {
      this.remove(product.variantId);
      return false;
    }

    this.add(product);
    return true;
  }

  exists(variantId) {
    return this.getItems().some((item) => item.variantId === variantId);
  }

  count() {
    return this.getItems().length;
  }

  clear() {
    localStorage.removeItem(this.storageKey);
  }
}

window.App = window.App || {};
window.App.wishlist = new Wishlist();

